/**
 * Environment Configuration
 * Type-safe access to environment variables
 */

interface EnvConfig {
    APP_NAME: string;
    APP_VERSION: string;
    API_URL: string;
    BACKEND_URL: string;
    API_TIMEOUT: number;
    ENVIRONMENT: 'development' | 'staging' | 'production';
    ENABLE_ANALYTICS: boolean;
    ENABLE_DEV_TOOLS: boolean;
    SENTRY_DSN?: string;
    GOOGLE_ANALYTICS_ID?: string;
    MAX_FILE_SIZE: number;
}

const api_url = import.meta.env.VITE_API_URL || '';

const getBackendUrl = (apiUrl: string) => {
    if (!apiUrl) return '';
    try {
        const urlObj = new URL(apiUrl);
        return urlObj.origin;
    } catch {
        return '';
    }
};

const env: EnvConfig = {
    APP_NAME: import.meta.env.VITE_APP_NAME || 'Enterprise React App',
    APP_VERSION: import.meta.env.VITE_APP_VERSION || '1.0.0',
    API_URL: api_url,
    BACKEND_URL: getBackendUrl(api_url),
    API_TIMEOUT: Number(import.meta.env.VITE_API_TIMEOUT) || 10000,
    ENVIRONMENT: (import.meta.env.MODE as EnvConfig['ENVIRONMENT']) || 'development',
    ENABLE_ANALYTICS: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
    ENABLE_DEV_TOOLS: import.meta.env.VITE_ENABLE_DEV_TOOLS !== 'false',
    SENTRY_DSN: import.meta.env.VITE_SENTRY_DSN,
    GOOGLE_ANALYTICS_ID: import.meta.env.VITE_GOOGLE_ANALYTICS_ID,
    MAX_FILE_SIZE: Number(import.meta.env.VITE_MAX_FILE_SIZE) || 5 * 1024 * 1024, // 5MB
};

// Validate required environment variables
const requiredEnvVars: (keyof EnvConfig)[] = ['API_URL', 'APP_NAME', 'BACKEND_URL'];

requiredEnvVars.forEach((key) => {
    if (!env[key]) {
        throw new Error(`Missing or invalid environment variable for: VITE_${key === 'BACKEND_URL' ? 'API_URL' : key}`);
    }
});

export default env;
